import { http } from "../../utils";

/**
 * @param {Object} data
 * @param {string} data.toAddress
 * @param {string} data.subject
 * @param {string} data.body
 * @returns {Promise<Object>}
 */
export async function sendEmail(data) {
  return http("/admin/test/send-email", {
    data: data,
  });
}

/**
 * @param {Object} data
 * @param {string} data.toPhone
 * @param {string} data.title
 * @param {string} data.content
 * @returns {Promise<Object>}
 */
export async function sendSms(data) {
  return http("/admin/test/send-sms", {
    data: data,
  });
}

/**
 * @param {Object} data
 * @param {string} data.trackingNo
 * @returns {Promise<Object>}
 */
export async function getTracking(data) {
  const endpoint = `/admin/test/get-tracking/${data.trackingNo}`;
  return http(endpoint);
}

/**
 * @param {Object} data
 * @param {string} data.bizNo
 * @returns {Promise<Object>}
 */
export async function getBizStatus(data) {
  const endpoint = `/admin/test/get-biz-status/${data.bizNo}`;
  return http(endpoint);
}
